import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "../../environments/environment";
import { MailgunSuppression, MailgunSuppressionRequest } from "../models/mailgun-suppression.model";

/**
 * PURPOSE: responsible for Mailgun suppression management API calls
 */
@Injectable({
  providedIn: "root"
})
export class MailgunSuppressionService {
  constructor(private http: HttpClient) {}

  searchSuppressions(emailAddress: string): Observable<MailgunSuppression[]> {
    return this.http
      .get<MailgunSuppression[]>(`${environment.fulcrumUrl}/api/v3/mailgun-suppression`, {
        ...this.buildBasicHttpOptions(),
        params: new HttpParams().set("emailAddress", emailAddress)
      })
      .pipe(
        catchError((error: HttpErrorResponse): Observable<never> => {
          console.error("Error searching suppressions:", error);
          return throwError(() => error);
        })
      );
  }

  addSuppression(request: MailgunSuppressionRequest): Observable<void> {
    return this.http
      .post<void>(
        `${environment.fulcrumUrl}/api/v3/mailgun-suppression`,
        request,
        this.buildBasicHttpOptions()
      )
      .pipe(
        catchError((error: HttpErrorResponse): Observable<never> => {
          console.error("Error adding suppression:", error);
          return throwError(() => error);
        })
      );
  }

  removeSuppression(emailAddress: string, domain: string): Observable<void> {
    return this.http
      .delete<void>(`${environment.fulcrumUrl}/api/v3/mailgun-suppression`, {
        ...this.buildBasicHttpOptions(),
        params: new HttpParams().set("emailAddress", emailAddress).set("domain", domain)
      })
      .pipe(
        catchError((error: HttpErrorResponse): Observable<never> => {
          console.error("Error removing suppression:", error);
          return throwError(() => error);
        })
      );
  }

  private buildBasicHttpOptions() {
    return {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization:
          "Basic " + btoa(`${environment.claimItApiUsername}:${environment.claimItApiPassword}`)
      })
    };
  }
}
